import styled from '@emotion/styled'
import { SearchInput } from 'view/components/inputs'
import { IconButton } from 'view/components/buttons'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'

export const BlotterToolbarContainer = styled.div`
  width: 100%;
  flex: 0 0 45px;
  background-color: ${constants.CORE_PRIMARY_1};
  display: flex;
  color: black;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
`

export const BlotterControls = styled.div`
  display: flex;
  flex: 0 0 auto;

  align-items: flex-end;
  justify-content: flex-end;
  color: black;
  ${mixins.flexCenterContentCrossAxis};
`

export const BlotterSearchBar = styled(SearchInput)`
  flex: 0 0 174px;
  margin-right: 20px;
`

export const SwitchStrip = styled.div`
  display: flex;
`

export const ToolbarToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  span > {
    font-size: 12px;
  }
  label > div {
    vertical-align: middle;
    margin-left: 5px;
  }
`

export const GroupByWrapper = styled.div`
  flex: 0 0 180px;
  margin-right: 20px;
`

export const BestPriceTypeWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-right: 20px;
  width: 200px;

  > span {
    color: ${constants.CORE_PRIMARY_6};
    flex: 0 0 auto;
    font-size: 11px;
    font-weight: ${constants.FontWeight.SemiBold};
    margin-right: 10px;
  }
`

export const CancelAllNegotiationsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`

export const CancelAllNegotiationsWarningsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const PageControlsToolbarContainer = styled(BlotterToolbarContainer)`
  justify-content: flex-end;
  flex: 0 0 35px;
  display: flex;
  align-items: center;

  span {
    font-weight: ${constants.FontWeight.Bold};
    margin: 0 3px;
  }

  ${IconButton} {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & > div:not(:last-of-type) {
    margin-right: 30px;
  }
`
